import React from 'react';
import { Shimmer, ShimmerPlaceholder } from '../../../../../../ui';
import styled from '@emotion/styled';
import {
	StyledMyBookingCard,
	StyledMyBookingCardRow,
	StyledMyBookingCardTitleRow,
} from './StyledMyBookingCard';

const RowShimmer = styled(Shimmer.withComponent(StyledMyBookingCardRow))``;

const TitleRowShimmer = styled(
	Shimmer.withComponent(StyledMyBookingCardTitleRow),
)``;

const TextPlaceholder = styled(ShimmerPlaceholder)`
	height: 30px;
	width: 70%;
`;

export const MyBookingCardShimmer = () => (
	<StyledMyBookingCard data-testid="shimmer">
		<RowShimmer>
			<TextPlaceholder />
		</RowShimmer>
		<TitleRowShimmer />
		<RowShimmer>
			<TextPlaceholder />
		</RowShimmer>
		<hr />
		<RowShimmer>
			<TextPlaceholder />
		</RowShimmer>
		<hr />
		<RowShimmer>
			<TextPlaceholder />
		</RowShimmer>
	</StyledMyBookingCard>
);
